<template>
	<Autocomplete
		display-name="Handwerkerauftrag Vorgang"
		:icon="icon"
		:label="label"
		:name="name"
		endpoint="craftsman_task_processes"
		item-title="name"
		v-bind="$attrs"
		data-test="craftsman_task_processes-autocomplete"
		:params="{ of: 'name', od: 'ASC' }"
	>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '@/components/templates/Validation/Autocomplete.vue'

defineProps({
	icon: {
		default: 'fal fa-cabinet-filing',
		type: String,
	},
	label: {
		default: 'Handwerkerauftrag Vorgang',
		type: String,
	},
	name: {
		default: 'craftsmanTaskProcesses',
		type: String,
	},
})
</script>

<style scoped></style>
